import styled from 'styled-components';

export const MessageListContainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.2rem 1.4rem;
  gap: 1.2rem;
  transition: background-color 0.4s ease-in-out; // 듀레이션 0.4초 추가
  cursor: pointer;
  &:nth-of-type(2n) {
    background: ${(props) => props.theme.colors.gray200};
  }
  &:hover {
    background-color: ${(props) => props.theme.colors.gray300};
  }
`;

export const MessageImage = styled.div`
  width: 4.4rem;
  min-width: 4.4rem;
  height: 4.4rem;
  background-color: ${(props) => props.theme.colors.main};
  border-radius: 2rem;
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${(props) => props.theme.colors.white};
  font-size: 1.4rem;
  font-weight: 700;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.15);

  /* 글자 간격 추가 */
  letter-spacing: 0.05rem; /* 원하는 간격으로 조절 */
  svg {
    color: ${(props) => props.theme.colors.buttonText};
  }
`;

export const MessageContents = styled.div`
  flex: 1;
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 0.4rem;

  font-size: 1.6rem;
  font-weight: 300;
  @media screen and (max-width: 380px) {
    font-size: 1.2rem;
  }
`;

export const HeaderButtonFont = styled.button`
  font-size: 1.6rem;
  font-weight: 700;
  color: ${(props) => props.theme.colors.txt200};
  &.active {
    color: ${(props) => props.theme.colors.main};
  }
`;

export const AddMain = styled.section`
  width: 100%;
  height: auto;

  padding: 0 1rem;

  display: flex;
  flex-direction: column;
  p {
    font-weight: ${(props) => props.theme.fontWeight.bold};
  }
  /* gap: 2rem; */
`;

export const AddInput = styled.input`
  width: 100%;
  height: 3rem;
  border-bottom: 1px solid ${(props) => props.theme.colors.gray500};
  color: ${(props) => props.theme.colors.txt500};

  ::placeholder {
    color: ${(props) => props.theme.colors.deactivation};
  }
  :focus {
    outline: 0;
  }
  font-size: 1.6rem;
`;
